import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import CategoryNav from '@/pages/home/components/CategoryNav';
import HotVideos from '@/pages/home/components/HotVideos';
import { useParams } from 'react-router-dom';
import { categoryDisplayNames } from '@/mocks/home';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categoryName = slug ? categoryDisplayNames[slug] || slug : '热门推荐';

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: categoryName },
  ];

  return (
    <>
      <Navbar />
      <main>
        <div className="pt-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2 mb-2">
              {categoryName}
            </h1>
          </div>
          <CategoryNav activeSlug={slug} />
          <HotVideos categorySlug={slug} limit={12} />
        </div>
      </main>
      <Footer />
    </>
  );
}